export * from './ScreenReaderAnnouncement.component';
